'use strict';

(function () {
  function initSizeGuide() {
    var triggers = document.querySelectorAll('[data-size-panel-trigger]');
    if (!triggers.length) return;

    var drawer = document.querySelector('[data-size-guide-drawer]');
    if (!drawer) return;

    var sid      = drawer.dataset.sizeGuideDrawer;
    var closeBtn = document.querySelector('[data-size-guide-close="' + sid + '"]');
    var overlay  = document.querySelector('[data-size-guide-overlay="' + sid + '"]');
    var lastTrigger = null;
    if (!overlay) return;

    /* Teleport drawer + overlay to <body> to escape any parent stacking context
       (position:fixed only covers the true viewport when it has no transformed/
       filtered ancestor). Visibility is driven purely by the body.size-guide-open
       class in CSS (see size-guide-drawer.css), matching the collection filter panel. */
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    function openDrawer(trigger) {
      lastTrigger = trigger;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-guide-open');
      if (window.__lenis) window.__lenis.stop();
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 50);
      document.addEventListener('keydown', onEsc);
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-guide-open');
      if (window.__lenis) window.__lenis.start();
      document.removeEventListener('keydown', onEsc);
      if (lastTrigger) lastTrigger.focus();
    }

    function onEsc(e) {
      if (e.key === 'Escape') closeDrawer();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () { openDrawer(trigger); });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    // Column switcher for ring size table
    var switcher = document.querySelector('[data-size-unit-switcher]');
    var table    = document.querySelector('[data-size-guide-table]');
    if (switcher && table) {
      switcher.querySelectorAll('[data-unit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.dataset.unit;
          switcher.querySelectorAll('[data-unit]').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          table.querySelectorAll('.sgd-col').forEach(function (col) {
            col.classList.remove('is-active');
          });
          table.querySelectorAll('.sgd-col--' + unit).forEach(function (col) {
            col.classList.add('is-active');
          });
        });
      });
    }

    initChainLengthUnitDropdown(drawer);
  }

  // ── Chain length guide: in/cm dropdown ──
  // Same trigger+menu pattern as the ring size picker's unit switcher
  // (.spd-unit-select in product-redesign.js) — a custom dropdown rather
  // than a native <select>, styled to match in size-guide-drawer.css.
  // Defaults to whichever unit the visitor's market normally uses
  // (localization.country.iso_code, rendered server-side into
  // [data-size-guide-drawer]'s data-market), always overridable by hand.
  function initChainLengthUnitDropdown(drawer) {
    var select  = drawer.querySelector('[data-chain-unit-select]');
    var trigger = drawer.querySelector('[data-chain-unit-trigger]');
    var label   = drawer.querySelector('[data-chain-unit-label]');
    var menu    = drawer.querySelector('[data-chain-unit-menu]');
    var table   = drawer.querySelector('[data-chain-length-table]');
    if (!select || !trigger || !menu || !table) return;

    var UNIT_NAMES = { in: 'in', cm: 'cm' };
    // Everyone outside these markets defaults to cm — an imperial-only
    // allowlist ages better than trying to enumerate every metric country.
    var IMPERIAL_MARKETS = ['US', 'LR', 'MM'];

    function applyUnit(unit) {
      table.querySelectorAll('tbody tr').forEach(function (row) {
        var cell = row.querySelector('td[data-in]');
        if (cell) cell.textContent = cell.dataset[unit === 'cm' ? 'cm' : 'in'];
      });
      if (label) label.textContent = UNIT_NAMES[unit];
      menu.querySelectorAll('.sgd-unit-select__option').forEach(function (opt) {
        var active = opt.dataset.unit === unit;
        opt.classList.toggle('is-active', active);
        opt.setAttribute('aria-selected', String(active));
      });
    }

    function closeMenu() {
      select.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = select.getAttribute('data-open') === 'true';
      if (isOpen) {
        closeMenu();
      } else {
        select.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    document.addEventListener('click', function (e) {
      if (!select.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    menu.querySelectorAll('[data-unit]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        applyUnit(opt.dataset.unit);
        closeMenu();
      });
    });

    var market = (drawer.dataset.market || '').toUpperCase();
    applyUnit(IMPERIAL_MARKETS.indexOf(market) !== -1 ? 'in' : 'cm');
  }

  document.addEventListener('DOMContentLoaded', initSizeGuide);
})();
